const appVersion = require('../../package.json').version
const environmentName = require('../../package.json')._envName
export const environment = {
  production: false,
  api_url: 'https://api.staging.platform.gcp.empact.online/api/',
  img_url: 'https://empact-dev-uploads.s3.amazonaws.com/',
  api_ecommerce_url: 'https://dev3.platform.empact.online/ecommerce-api/',
  pk_stripe: 'pk_live_51HMDlIKQqSuACCb127LsQLqDEvmCWH6xY5Y2P2uEow0rl4d99HfVmm79K3ulLtEUsXPnmYp7V0Ul1yvlnbfd9trl00ZTfj4LM4',
  sandbox_pk_stripe: 'pk_test_51HMDlIKQqSuACCb1TiAKdtLG7eqPk83Fgc020P67gRWiSZSublUgbzhXjbEx5BbOSRC46ouWQ3Kqb9fAesFlxPKx009mOR1xuq',
  one_time_registration_fees: 150,
  monthly_subscription_fees: 299,
  one_time_registration_fees_indvat: 150,
  monthly_subscription_fees_indvat: 199,
  partner_customer_monthly_fee: 299,
  partner_customer_registration_fee: 150,
  partner_reporting_customer_monthly_fee: 199,
  partner_b2c_commission: 0.25,
  partner_b2b_commission: 10,
  partner_total_so_month: 9040,
  partner_euro_per_so: 0.35,
  b2b_handling_fees: 10,
  b2c_handling_fees: 1,
  b2c_yearly_handling_fees: 1,
  appVersion: 'pipeline-gcp/staging_0.11.159',
  is_live_mode: false,
  integration_layer_url: 'https://dev.integrationlayer.platform.empact.zangula.net/',
  isFedex: false,
  isDemo: true,
  paypal_client_id: 'ASTuLOurPxlu6-TomUyUO1NXPDCy0sW4Y59S94cDEdTbR-UnIFUuQD4i0Ti03k7d6slfczGZa8UJfyE9',
    paypal_currency: 'EUR',
  // appVersion: 'pipeline-gcp/staging_0.11.159',
};
